export default class Camera
{
	minDate=2000
	yearToPixels=100
}